<!-- Page Header -->
<section class="cuspage-hero">
    <div class="cuspage-hero__bg"></div>
    <div class="container">
        <div class="cuspage-hero__content">
             <span class="cuspage-hero__tagline" style="display:none;">
                <i class="icofont-justice-hammer"></i>
                {{ 'suivi_titre' | translate }}
            </span>
            <h1 class="cuspage-hero__title"> {{ 'suivi_titre' | translate }}</h1>
            <p class="cuspage-hero__sub">{{ 'suivi_sous_titre' | translate }}</p>  
        </div>
    </div>
</section>


<!-- Suivi Section -->
<section class="arp-suivi-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-7 col-lg-8">

        <!-- Title + Search form -->
        <div class="sec-title text-center wow fadeInUp" data-wow-delay="100ms" style="display:none;">
          <span class="sec-title__tagline">{{ 'suivi_tagline' | translate }}</span>
          <h3 class="sec-title__title">{{ 'suivi_titre' | translate }}</h3>
          <p class="sec-title__text">{{ 'suivi_sous_titre' | translate }}</p>
        </div>

        <div class="arp-track-form wow fadeInUp" data-wow-delay="200ms">
          <div class="arp-track-input-row">
            <div class="arp-track-input-wrap">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35" stroke-linecap="round"/>
              </svg>
              <input type="text" class="arp-track-input"
                [(ngModel)]="reference"
                [placeholder]="'suivi_saisir_ref' | translate"
                (keyup.enter)="track()">
            </div>
            <button class="careox-btn" (click)="track()" [disabled]="loading || !reference.trim()">
              <span *ngIf="loading" class="arp-spinner"></span>
              <span>{{ loading ? ('suivi_recherche_en_cours' | translate) : ('suivi_rechercher' | translate) }}</span>
            </button>
          </div>
          <p class="arp-track-hint">{{ 'suivi_hint' | translate }}</p>
        </div>

        <!-- Error -->
        <div *ngIf="error" class="arp-alert-error wow fadeInUp">{{ error }}</div>

        <!-- ── Result ── -->
        <div *ngIf="complaint" class="arp-result wow fadeInUp" data-wow-delay="100ms">

          <!-- Summary card -->
          <div class="arp-complaint-card">
            <div class="arp-complaint-card__header">
              <div>
                <span class="arp-complaint-card__ref">{{ complaint.complaint_number }}</span>
                <h4 class="arp-complaint-card__subject">{{ getSubject() || complaint.complainant_name }}</h4>
              </div>
              <div>
                <span [class]="'arp-status-badge ' + getStatusClass(complaint.status)">
                  {{ getStatusLabel(complaint.status) }}
                </span>
              </div>
            </div>
            <div class="arp-complaint-card__meta">
              <div class="arp-meta-item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" stroke-linecap="round"/>
                </svg>
                {{ complaint.complainant_name }}
              </div>
              <div class="arp-meta-item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                </svg>
                {{ formatDate(complaint.created_at) }}
              </div>
              <div class="arp-meta-item">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                  <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
                </svg>
                <span [class]="'arp-priority-tag priority-' + complaint.priority">
                  {{ getPriorityLabel(complaint.priority) }}
                </span>
              </div>
            </div>
          </div>

          <!-- Progress timeline -->
          <div class="arp-timeline">
            <h5 class="arp-timeline__title">{{ 'suivi_etapes' | translate }}</h5>
            <div class="arp-timeline__steps">
              <div *ngFor="let step of steps; let last = last"
                class="arp-timeline__step"
                [class.done]="step.done"
                [class.active]="step.active">
                <div class="arp-timeline__connector" *ngIf="!last"></div>
                <div class="arp-timeline__dot">
                  <!-- pending icon -->
                  <svg *ngIf="step.icon === 'pending'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                  </svg>
                  <!-- progress icon -->
                  <svg *ngIf="step.icon === 'progress'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                  </svg>
                  <!-- resolved icon -->
                  <svg *ngIf="step.icon === 'resolved'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                  <!-- closed icon -->
                  <svg *ngIf="step.icon === 'closed'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                  </svg>
                </div>
                <div class="arp-timeline__content">
                  <span class="arp-timeline__step-label">{{ step.label | translate }}</span>
                  <span class="arp-timeline__step-desc">{{ step.desc | translate }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Resolution notes if resolved -->
          <div *ngIf="complaint.resolution_notes" class="arp-resolution-note">
            <h6>{{ 'suivi_notes_resolution' | translate }}</h6>
            <p>{{ complaint.resolution_notes }}</p>
          </div>

          <!-- New search -->
          <div class="text-center mt-4">
            <button class="careox-btn careox-btn--ghost" (click)="reset()">
              <span>{{ 'suivi_nouvelle_recherche' | translate }}</span>
            </button>
          </div>

        </div>

      </div>
    </div>
  </div>
</section>
